import React from 'react';

import { Heading } from '@auspost/postmaster-react';

import styles from './RowCard.module.scss';

export interface RowCardProps {
  groupHeading?: string;
  children?: React.ReactNode;
}

const RowCard: React.FC<RowCardProps> = ({ groupHeading, children, ...props }) => (
  <div className={styles.rowCard} {...props}>
    {groupHeading && (
      <Heading level='h5' className={styles.groupHeading}>
        {groupHeading}
      </Heading>
    )}
    <div className={styles.rowCardWrapper}>{children}</div>
  </div>
);

export default RowCard;
